// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "d165d701db61eb3dbb44a8bc7e20def9e13fceb3/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};